import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=a2c80e9a&scoped=true&"
import script from "./ErrorLogs.vue?vue&type=script&lang=js&"
export * from "./ErrorLogs.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLogs.vue?vue&type=style&index=0&id=a2c80e9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c80e9a",
  null
  
)

export default component.exports